import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerViewProfileComponent } from './components/common/customer-view-profile/customer-view-profile.component';
// import { RegisterComponent } from './components/register/register.component';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { BrokerManagementComponent } from './modules/admin-forms/broker-management/broker-management.component';
import { EditViewEmployeesComponent } from './modules/admin-forms/edit-view-employees/edit-view-employees.component';
import { EmployeeCallReportsComponent } from './modules/admin-forms/employee-call-reports/employee-call-reports.component';
import { EmployeeActivityPointsComponent } from './modules/admin-forms/employee-activity-points/employee-activity-points.component';
import { MasterPageComponent } from './modules/admin-forms/master-page/master-page.component';
import { UpdateBranchComponent } from './modules/admin-forms/update-branch/update-branch.component';
import { LstComponent } from './modules/matchfollowup/lst/lst.component';
import { MyProfileOldComponent } from './modules/matchfollowup/my-profile-old/my-profile-old.component';
import { MyProfileComponent } from './modules/matchfollowup/my-profile/my-profile.component';
import { ReportsModule } from './modules/reports/reports-module';

const routes: Routes = [
  // { path: '', component: HomeComponent },
  {
    path: '',
    loadChildren: () =>
      import('./components/home/home.module').then((m) => m.HomeModule)
  },
  {
    path: 'emailVerify/:code',
    loadChildren: () =>
      import('./components/verification/email/email-verify.module').then(
        (m) => m.EmailVerifyModule
      ),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./components/register/register.module').then(
        (m) => m.RegisterModule
      ),
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),canActivate: [AuthGuard]
  },
  { path: 'viewProfilePage', component: CustomerViewProfileComponent },

  // { path: 'register', component: RegisterComponent },

  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'showAll',
    loadChildren: () =>
      import(
        './components/dashboard/show-all-dynamic-profiles/show-all-dynamic-profiles.module'
      ).then((m) => m.ShowAllDynamicProfilesModule),
  },
  {
    path: 'showAll/:show',
    loadChildren: () =>
      import(
        './components/dashboard/show-all-dynamic-profiles/show-all-dynamic-profiles.module'
      ).then((m) => m.ShowAllDynamicProfilesModule),
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('./components/common/feedback/feedback.module').then(
        (m) => m.FeedbackModule
      ),
  },
  { path: 'showcompleteprofile', loadChildren: () => import('./components/dashboard/show-all/show-all.module').then(m => m.ShowAllModule),canActivate: [AuthGuard] },
  { path: 'inbox', loadChildren: () => import('./components/dashboard/inbox/inbox.module').then(m => m.InboxModule),canActivate: [AuthGuard] },
  { path: 'myaccount', loadChildren: () => import('./components/dashboard/myaccount/myaccount.module').then(m => m.MyaccountModule),canActivate: [AuthGuard] },
  { path: 'search', loadChildren: () => import('./components/dashboard/profile-search-compoenent/profile-search-compoenent.module').then(m => m.ProfileSearchCompoenentModule),canActivate: [AuthGuard] },
  { path: 'employee', loadChildren: () => import('./employee/change-type/change-type.module').then(m => m.ChangeTypeModule),canActivate: [AuthGuard] },
  { path: 'profileAssign', loadChildren: () => import('./admin/modules/admindashboard/admindashboard.module').then(m => m.AdmindashboardModule),canActivate: [AuthGuard] },
  { path: 'membership', loadChildren: () => import('./admin/modules/membership-offer/membership-offer.module').then(m => m.MembershipOfferModule) },
  { path: 'registrationprofile', loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule) },
  { path: 'viewProfile', loadChildren: () => import('./modules/view-profile/view-profile.module').then(m => m.ViewProfileModule) },
  { path: 'paymentDetails', loadChildren: () => import('./modules/payment/payment.module').then(m => m.PaymentModule),canActivate: [AuthGuard] },
  { path: 'addPaymentDetails', loadChildren: () => import('./modules/add-payment-details/add-payment-details.module').then(m => m.AddPaymentDetailsModule),canActivate: [AuthGuard] },
  { path: 'paymentOffers', loadChildren: () => import('./modules/payment-offers/payment-offers.module').then(m => m.PaymentOffersModule),canActivate: [AuthGuard] },
  { path: 'marketingSlideShow', loadChildren: () => import('./modules/marketing/marketing.module').then(m => m.MarketingModule),canActivate: [AuthGuard] },
  { path: 'guestTicketCreation', loadChildren: () => import('./modules/guest-ticket/guest-ticket.module').then(m => m.GuestTicketModule),canActivate: [AuthGuard] },
  { path: 'matchfollowup', loadChildren: () => import('./modules/matchfollowup/matchfollowup.module').then(m => m.MatchfollowupModule),canActivate: [AuthGuard] },
  { path: 'lst', component: LstComponent, canActivate: [AuthGuard] },
  { path: 'myprofile', component: MyProfileComponent, canActivate: [AuthGuard] },
  { path: 'myprofileold', component: MyProfileOldComponent, canActivate: [AuthGuard]},
  { path: 'task-details', loadChildren: () => import('./modules/reports/emp-routing/emp-routing.module').then(m => m.EmpRoutingModule),canActivate: [AuthGuard] },

  { path: 'customerNewAdminProfile', loadChildren: () => import('./modules/admin-profile/admin-profile.module').then(m => m.AdminProfileModule) ,canActivate: [AuthGuard]},
  { path: 'customerregistration', loadChildren: () => import('./modules/customerregister/customerregister.module').then(m => m.CustomerregisterModule),canActivate: [AuthGuard] },
  { path: 'editViewProfile', loadChildren: () => import('./modules/edit-view/edit-view.module').then(m => m.EditViewModule),canActivate: [AuthGuard] },
  { path: 'expressInterest', loadChildren: () => import('./modules/expressinterest/expressinterest.module').then(m => m.ExpressinterestModule) ,canActivate: [AuthGuard]},
  { path: 'communicationLog', loadChildren: () => import('./modules/communicationlog/communicationlog.module').then(m => m.CommunicationlogModule),canActivate: [AuthGuard] },

  { path: 'searchprofile', loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule) },

  { path: 'editViewDashBoard', loadChildren: () => import('./modules/education/education.module').then(m => m.EducationModule),canActivate: [AuthGuard] },
  { path: 'paymentAuthorization', loadChildren: () => import('./modules/payment-auth/payment-auth.module').then(m => m.PaymentAuthModule),canActivate: [AuthGuard] },
  { path: 'upload-view-sa', loadChildren: () => import('./modules/settlement-form/settlement-form.module').then(m => m.SettlementFormModule),canActivate: [AuthGuard] },
  { path: 'matchMeeting', loadChildren: () => import('./modules/match-meeting/match-meeting.module').then(m => m.MatchMeetingModule),canActivate: [AuthGuard] },
  { path: 'marketingReassign', loadChildren: () => import('./admin/modules/unassign-profile/unassign-profile.module').then(m => m.UnassignProfileModule) },
  { path: 'serviceSlideShow', loadChildren: () => import('./modules/service-slide-show/service-slide-show.module').then(m => m.ServiceSlideShowModule) },
  { path: 'employee-permission', loadChildren: () => import('./modules/admin-forms/admin-forms.module').then(m => m.AdminFormsModule),canActivate: [AuthGuard]},
  { path: 'reports', loadChildren:() => import('./modules/reports/reports-module').then(m => m.ReportsModule)},
  {path: 'master-page', component: MasterPageComponent},
  { path: 'edit-view-employees', component:EditViewEmployeesComponent},
  { path: 'employee-call-reports', component:EmployeeCallReportsComponent},
  { path: 'employee-activity-points', component:EmployeeActivityPointsComponent},
  { path: 'update-branch', component: UpdateBranchComponent, canActivate: [AuthGuard]},
  { path: 'broker-management', component: BrokerManagementComponent, canActivate: [AuthGuard]},
  //{ path: 'officePurpose', loadChildren: () => import('./modules/edit-office-purpose/edit-office-purpose.module').then(m => m.EditOfficePurposeModule) },
  //{ path: 'references', loadChildren: () => import('./modules/edit-view-references/edit-view-references.module').then(m => m.EditViewReferencesModule) },
  //{ path: 'relativeDetails', loadChildren: () => import('./modules/relative/relative.module').then(m => m.RelativeModule) },
  // { path: 'propertyDetails', loadChildren: () => import('./modules/property/property.module').then(m => m.PropertyModule) },
  // { path: 'aestroDetails', loadChildren: () => import('./modules/aestro/aestro.module').then(m => m.AestroModule) },
  // { path: 'managePhotos', loadChildren: () => import('./modules/manage-photos/manage-photos.module').then(m => m.ManagePhotosModule) },


  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
  // { path: 'product-detail/:id', component: ProductDetailComponent },
  // { path: 'contact', component: ContactComponent },
  // { path: '**', component: NoPageFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
